import {
  AssessmentEntry,
  AssessmentEntryComment,
  AssessmentEntryGrade,
  AssessmentEntryScore,
  AssessmentMethod,
  AssessmentMethodComment,
  AssessmentMethodGrade,
  AssessmentMethodScore,
  AssessmentMethodType,
} from './apiTypes/assessments';

export const isAssessmentEntryComment = (
  entry: AssessmentEntry,
): entry is AssessmentEntryComment => {
  return entry.method.type === AssessmentMethodType.Comment;
};

export const isAssessmentEntryScore = (entry: AssessmentEntry): entry is AssessmentEntryScore => {
  return entry.method.type === AssessmentMethodType.Score;
};

export const isAssessmentEntryGrade = (entry: AssessmentEntry): entry is AssessmentEntryGrade => {
  return entry.method.type === AssessmentMethodType.Grade;
};

export const isAssessmentMethodComment = (
  method: AssessmentMethod,
): method is AssessmentMethodComment => {
  return method.method_type === AssessmentMethodType.Comment;
};

export const isAssessmentMethodGrade = (
  method: AssessmentMethod,
): method is AssessmentMethodGrade => {
  return method.method_type === AssessmentMethodType.Grade;
};

export const isAssessmentMethodScore = (
  method: AssessmentMethod,
): method is AssessmentMethodScore => {
  return method.method_type === AssessmentMethodType.Score;
};
